var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capitol"
  }, /*#__PURE__*/React.createElement("g", {
    id: "capitol--capitol-travel-places"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 612",
    d: "M33.1551 22.0768H2.14258L17.6476 13.2168L33.1551 22.0768Z",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 613",
    d: "M2.14258 33.1523H33.1551",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 614",
    d: "M4.35767 22.0771V33.1521",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 616",
    d: "M11 22.0771V33.1521",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1054",
    d: "M17.6501 22.0771V33.1521",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 617",
    d: "M24.2925 22.0771V33.1521",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 615",
    d: "M30.9402 22.0771V33.1521",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1313",
    d: "M8.7876 18.2398V14.3248C8.7876 11.975 9.72106 9.72145 11.3826 8.05988C13.0442 6.39831 15.2978 5.46484 17.6476 5.46484C19.9974 5.46484 22.251 6.39831 23.9126 8.05988C25.5741 9.72145 26.5076 11.975 26.5076 14.3248V18.2398",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1053",
    d: "M17.6501 5.46215V2.13965",
    stroke: "#C1C1C1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMos);
export default __webpack_public_path__ + "static/media/mos.6bb3c2ca41876e27b56149b28b4c715d.svg";
export { ForwardRef as ReactComponent };